import React from 'react'
import { Box, Typography, styled } from '@mui/material'
import ContactForm from './ContactForm'
import Pic from '../../resources/IMG_5555.jpeg'
import { Column, Row, SwapRow } from '../../components/Common/CommonComponents'
import { LocationOn, Phone, Email } from '@mui/icons-material'
import Footer from '../../components/Footer/Footer'

const PageContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'calc(100vw - 72px)',
  paddingLeft: '36px',
}))

const PicContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '280px',
  backgroundImage: `url(${Pic})`,
  backgroundRepeat: 'center no-repeat',
  backgroundSize: 'cover',
  loading: 'eager',
  alignItems: 'center',
  borderRadius: '12px',
  marginBottom: '24px',
}))

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.grey[50],
  padding: '36px',
  [theme.breakpoints.down('md')]: {
    padding: '12px',
  },
}))

const TitleContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '0 0 36px 6px',
  gap: '12px',
}))

const InfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: theme.palette.background.paper,
  padding: '24px',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.grey[300]}`,
  gap: '24px',
}))

const IconContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.shade?.p4,
  color: theme.palette.primary.light,
  padding: '8px',
  borderRadius: '12px',
}))

const ContactPage = () => (
  <PageContainer>
    <Container>
      <TitleContainer>
        <Typography variant='h3' color='text.primary'>SECURE YOUR SPLASH.</Typography>
        <Typography variant='body1' color='text.primary'>Experience the luxury of a crystal-clear sanctuary. Our aquatic experts are ready to transform your maintenance routine into effortless excellence.</Typography>
      </TitleContainer>
          <SwapRow size="md" gap="24px" width="100%">
        <ContactForm />
        <Column sx={{ gap: '12px', flex: {xs: 1, md: 0.7 }}}>
          <InfoContainer>
            <Box>
              <IconContainer>
                <LocationOn />
              </IconContainer>
            </Box>
            <Column>
            <Typography variant='subtitle1' color='text.primary'>Location</Typography>
            <Typography variant='body1' color='text.primary'>Sydney</Typography>
            </Column>
          </InfoContainer>
          <InfoContainer>
            <Box>
              <IconContainer>
                <Phone />
              </IconContainer>
            </Box>
            <Column>
            <Typography variant='subtitle1' color='text.primary'>Phone</Typography>
            <Typography variant='body1' color='text.primary'>(0466) 400-747</Typography>
            </Column>
          </InfoContainer>
          <InfoContainer>
            <Box>
              <IconContainer>
                <Email />
              </IconContainer>
            </Box>
            <Column>
            <Typography variant='subtitle1' color='text.primary'>Email</Typography>
            <Typography variant='body1' color='text.primary'>nickhardie3@gmail.com</Typography>
            </Column>
          </InfoContainer>
        <PicContainer />
        </Column>
      </SwapRow>
    </Container>  
    <Row width="100vw">
      <Footer />
    </Row>
  </PageContainer>
)

export default ContactPage